export const matchPlanIdRegex = /(?:^|\.)plan\[(.*)\]/;
export const capturePlanUpdatePath = /(?:(?:^|\.)plan\[.*\]\.)(.*)/;
export const matchBundlePath = /(bundles\.[0-9]*)/;
